/**
 * Spacing values mapping to Tailwind's space-y-* classes
 * Default: 2.5 (10px)
 * Override example: spacing="1" for 4px (used in primary sidebar)
 */
export type SpacingValue = '0' | '0.5' | '1' | '1.5' | '2' | '2.5' | '3' | '4'

export const SPACING_CLASS_MAP: Record<SpacingValue, string> = {
  '0': 'space-y-0',
  '0.5': 'space-y-0.5',
  '1': 'space-y-1',
  '1.5': 'space-y-1.5',
  '2': 'space-y-2',
  '2.5': 'space-y-2.5',
  '3': 'space-y-3',
  '4': 'space-y-4'
}

export const DEFAULT_SIDEBAR_ITEM_SPACING: SpacingValue = '2.5'
